function ValidateDynamicDemo(selectedDynamicDemo) {
	var validationErrors = [];                
	if (!selectedDynamicDemo.dynamicDemoQuestion.demoQuestionCode || selectedDynamicDemo.dynamicDemoQuestion.demoQuestionCode === '') {                    
		addErrorMessage(validationErrors, 'demoQuestionCode', 'Dynamic demographic demo question code is empty');
	}
	if (!selectedDynamicDemo.dynamicDemoQuestion.demoQuestionText || selectedDynamicDemo.dynamicDemoQuestion.demoQuestionText === '') {                    
		addErrorMessage(validationErrors, 'demoQuestionText', 'Dynamic demographic demo question text is empty');
	}
	if (selectedDynamicDemo.comparisonType == null) {
		addErrorMessage(validationErrors, 'comparisonType', 'Comparison type is empty');
	}
	if (selectedDynamicDemo.numberOfDays == null) {                    
		addErrorMessage(validationErrors, 'numberOfDays', 'Numbers of days is empty');
	}
	if (selectedDynamicDemo.numberOfTimes == null) {                    
		addErrorMessage(validationErrors, 'numberOfTimes', 'Numbers of times is empty');
	}
	if (!selectedDynamicDemo.dynamicDemographicParams || selectedDynamicDemo.dynamicDemographicParams.length === 0) {                    
		addErrorMessage(validationErrors, 'numberOfTimes', 'Numbers of times is empty');
	}	
	
	return validationErrors;
}

function addErrorMessage(validationErrors, field, message) {      
	validationErrors.push({ field: field, errorMessage: message});      
}

export default ValidateDynamicDemo;